/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/button-has-type */
import React,{useState,useRef} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon, { IconType, IconSize } from '../icon/icon';
import { ButtonSize } from '../button/button';
import Modal,{ ModalSize } from '../../molecules/modal/modal';
import FormInputText from '../../molecules/formInputText/formInputText';
import Button, { ButtonTheme, ButtonType } from '../../atoms/button/button';
import FormInputTypes from '../formEnums/formInputTypes';
import { httpPost, httpPostGetFile } from '../../../store/externalCalls/httpCalls';
import Toaste from '../toast/toaste';
import FormGroup from '../../organisms/formGroup/formGroup2';
import { useParams } from 'react-router-dom';
import Label from '../label/label';

export const ButtonkSize = {
  BLOCK: 'block',
  LARGE: 'lg',
  SMALL: 'sm',
  '': '',
};

/**
 * Basic link component, it’s designed to edit the href attribute
 */
const ButtonSimple = (props) => {
  const {
    id,label, buttonText,handler,value,helpText,onUpdate,disabled
  } = props;
  
  const handlerOnClick=(e,handler)=>{
    switch (handler){
      case "copyPosterValues":
          copyColorsFromPoster();
        break;
    }
    
  }

  const copyColorsFromPoster=()=>{
    let updated=value;
    updated.extendedInfoTagMode=updated.posterTagMode;
    updated.extendedInfoTextColor=updated.posterTextColor;
    updated.extendedInfoBkColor=updated.posterBkColor;
    updated.extendedInfoLabel=updated.posterLabel;
    updated.extendedInfoIconId=updated.posterIconId;
    updated.extendedInfoFont=updated.posterFont;
    onUpdate(updated);
  }
  return (
    <div>
       <div className={`form-group row`}>
            { label !== ''
              && (
                <Label helpText={helpText} >{label}</Label>
              )}
            <div className="col-sm-8">
              <Button 
                  id={`button-`+id}
                  theme={ButtonTheme.PRIMARY}
                  onClick={(e)=>{handlerOnClick(e,handler)}}
                  disabled={disabled}
                >
                  {buttonText}
              </Button>
            </div>
            </div>
    </div>
  );
};

ButtonSimple.propTypes = {
  /**
   * Link background color
   */
  theme: PropTypes.oneOf(Object.values(ButtonTheme)),
  /**
   * Link general size
   */
  size: PropTypes.oneOf(Object.values(ButtonSize)),
  /**
   * Content to put inside the link component
   */
  children: PropTypes.node,
  /**
   * CSS classes to customize link
   */
  className: PropTypes.string,
  /**
   * To select a icon inside the link
   */
  icon: PropTypes.oneOf(Object.values(IconType)),
  /**
   * Icon color inside the link
   */
  iconColor: PropTypes.string,
  /**
   * Icon size inside the link
   */
  iconSize: PropTypes.oneOf(Object.values(IconSize)),
  /**
   * To disable the link functionality
   */
  disabled: PropTypes.bool,
  /**
   * Link reference
   */
  to: PropTypes.string,
  confirm: PropTypes.bool,
  onUpdateForm: PropTypes.func,
  mode:PropTypes.string


};

ButtonSimple.defaultProps = {
  theme: '',
  size: ButtonSize.SMALL,
  children: null,
  className: '',
  icon: '',
  iconColor: '',
  iconSize: IconSize.SMALL,
  disabled: false,
  confirm:false,
  mode:'link',
  onUpdateForm: () => { },

};

export default ButtonSimple;
